<template>
    <div style="width: 300px">
                <v-daterange v-model="range" :presets="presets"
                 start-label="Start Date"
                 end-label="End Date"
                 separator-label=""
                 title="Date Range">
                </v-daterange>
    </div>
</template>

<script>
import { format, subDays, subYears } from 'date-fns';
  export default {
    name: 'DateRangeSelector',
    props: ['value'],
    watch: {
      value () {
        if(this.range !==this.value){
          this.range = {...this.value}
        }
      },
      range (newRange,oldRange) {
        this.$emit('input', newRange)
          if(newRange&&oldRange&&(newRange.start!=oldRange.start||newRange.end!=oldRange.end)){
              this.$emit('change', newRange)
          }
      }
    },
      created(){
        this.range=this.value&&this.value.start ? {...this.value} : {
            start: format(subYears(new Date(), 1), 'YYYY-MM-DD'),
            end: format(subDays(new Date(),-1), 'YYYY-MM-DD')
        }
      },
    mounted () {
      if (!this.value) {
        this.$emit('input', this.range)
      }else if (!this.value.start) {
        this.$emit('input', this.range)
      } else {
        this.range = {...this.value}
      }
    },
    data () {
      return {
        range: null,
        presets: [
        {
          label: 'Today',
          range: [
            format(new Date(), 'YYYY-MM-DD'),
            format(subDays(new Date(), -1), 'YYYY-MM-DD')
          ]
        },
        {
          label: 'Yesterday',
          range: [
            format(subDays(new Date(), 1), 'YYYY-MM-DD'),
            format(subDays(new Date(), 0), 'YYYY-MM-DD')
          ]
        },
        {
          label: 'Last 30 Days',
          range: [
            format(subDays(new Date(), 30), 'YYYY-MM-DD'),
            format(subDays(new Date(), -1), 'YYYY-MM-DD')
          ]
        }
      ]
      }
    }

  }
</script>

<style>
.v-date-range .v-menu--inline{
    display: block !important;
}
</style>
